// extracted by mini-css-extract-plugin
export default {"bannerContainer":"_71FtDzC3WU9AzrtSy+X8bA==","icon":"Csp1jaxnGxQT0ouSUK0mkw==","message":"kO5vKa+Mkoz0xniM0V6EUQ==","buttonContainer":"iWWxf7AgB9I67T-eeash0A=="};